import TournamentList from './TournamentList';

export default TournamentList;
